import { useLine } from 'hooks/use-line';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'hooks/use-auth';

export const useRemoteLineDetails = () => {
  const { settings, unit, setQuantity } = useLine();
  const { user } = useAuth();
  const { t } = useTranslation();

  return {
    settings,
    unit,
    setQuantity,
    user,
    t,
  };
};
